"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _ = require("..");

var PageMetricsProvider = function PageMetricsProvider(_ref) {
  var pageId = _ref.pageId,
      pathname = _ref.pathname,
      attributes = _ref.attributes,
      GDPR = _ref.GDPR,
      user = _ref.user,
      country = _ref.country,
      children = _ref.children;
  var _GDPR$hasGDPRConsent = GDPR.hasGDPRConsent,
      hasGDPRConsent = _GDPR$hasGDPRConsent === void 0 ? false : _GDPR$hasGDPRConsent;
  var _user$id = user.id,
      userId = _user$id === void 0 ? '1' : _user$id,
      _user$package = user["package"],
      packageId = _user$package === void 0 ? '1' : _user$package,
      _user$email = user.email,
      email = _user$email === void 0 ? '' : _user$email;
  (0, _react.useEffect)(function () {
    _.MetricsTracker.track({
      name: _.USER_EVENTS.PAGE_VIEW,
      data: {
        actionType: _.USER_EVENTS.PAGE_VIEW,
        actionFlow: pageId,
        pathname: pathname,
        pageId: pageId,
        attributes: attributes,
        data: {
          hasGDPRConsent: hasGDPRConsent,
          userId: userId,
          packageId: packageId,
          email: email,
          country: country
        }
      }
    });
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [
    /**
     * Adding an empty array ensures that this is always and only called
     * on first page renders/reloads. SPA will never call this.
     */
  ]);
  return children;
};

var _default = PageMetricsProvider;
exports["default"] = _default;
module.exports = exports["default"];